import { ApiEndpoints } from 'models'
import { apiGet, apiPostLogout } from 'services/api'

export async function getIdpInfo() {
  return apiGet(ApiEndpoints.getIdpInfo)
    .then((response) => {
      return { status: response.status, ...response.body }
    })
    .catch((err) => {
      throw err
    })
}

export async function performLogout() {
  return apiPostLogout(ApiEndpoints.logout)
    .then((response) => {
      return { status: response.status, body: response.body }
    })
    .catch((err) => {
      throw err
    })
}
